import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fallback-logo",
  "use": "icon-fallback-logo-usage",
  "viewBox": "0 0 600 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 600 200\" id=\"icon-fallback-logo\">\n  <rect fill=\"none\" width=\"100%\" height=\"100%\" />\n  <text x=\"50%\" y=\"50%\" dominant-baseline=\"middle\" text-anchor=\"middle\" font-family=\"Arial, Helvetica, sans-serif\" font-size=\"28\" fill=\"white\">\n    LOGO\n  </text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol